import { resolveInvalidationTemplates } from '@portal/rocket-api-client';
import { QueryClientProvider as ReactQueryClientProvider } from '@tanstack/react-query';

import { createQueryClient } from '@shared/api/createQueryClient';

import { mapAxiosErrorToRocketError } from '../../util/apiErrors';

export const queryClient = createQueryClient({
  mapAxiosErrorToRocketError,
  resolveInvalidationTemplates,
});

export default function QueryClientProvider({ children }: { readonly children: React.ReactNode }) {
  return <ReactQueryClientProvider client={queryClient}>{children}</ReactQueryClientProvider>;
}
